import { render, staticRenderFns } from "./AcompanhamentoTabela.vue?vue&type=template&id=5d18a5b0&"
import script from "./AcompanhamentoTabela.vue?vue&type=script&lang=js&"
export * from "./AcompanhamentoTabela.vue?vue&type=script&lang=js&"
import style0 from "./AcompanhamentoTabela.vue?vue&type=style&index=0&id=5d18a5b0&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports